module.exports = __webpack_public_path__ + "img/0-90.4f97170d.jpg";